var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d', {
  willReadFrequently: true
});

function applyOriginalImageChanges(originalImage, width, height) {
  if (!ctx) return new ImageData(0, 0);
  ctx.canvas.width = width;
  ctx.canvas.height = height;
  ctx.drawImage(originalImage, 0, 0, ctx.canvas.width, ctx.canvas.height);
  return ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
}

export { applyOriginalImageChanges as default };
